import type { ProductsQueryParams, ProductsResponse } from '../shared/types';
import { authenticatedFetch } from '../shared/authenticatedFetch';
// import { sanitizeProducts } from '../shared/sanitizeProducts';

export async function getProducts(apiUrl: string, params?: ProductsQueryParams): Promise<ProductsResponse> {
    const url = new URL(`${apiUrl}/products`);

    if (params?.division) {
        url.searchParams.set('division', params.division);
    }
    if (params?.softwareCompany) {
        url.searchParams.set('softwareCompany', params.softwareCompany);
    }
    if (params?.projectName) {
        url.searchParams.set('projectName', params.projectName);
    }
    if (params?.fiscalYearQuarter) {
        url.searchParams.set('fiscalYearQuarter', params.fiscalYearQuarter);
    }
    if (params?.fiscalYear) {
        url.searchParams.set('fiscalYear', params.fiscalYear);
    }
    if (params?.limit != null) {
        url.searchParams.set('limit', params.limit.toString());
    }
    if (params?.page != null) {
        url.searchParams.set('page', params.page.toString());
    }

    const response = await authenticatedFetch(url.toString());
    const data: ProductsResponse = await response.json();
    //   return sanitizeProducts(data);
    return data;
}
